import FilterSelect from 'common/components/FilterSelect'
import {FC} from 'react'
import {FormattedMessage} from 'react-intl'
import ReactPaginateLib from 'react-paginate'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

import {PaginationProps} from './types'

// react-paginate is a webpack UMD bundle; esbuild misses the non-enumerable __esModule flag
const ReactPaginate = ((ReactPaginateLib as any).default ??
  ReactPaginateLib) as typeof ReactPaginateLib

const Pagination: FC<PaginationProps> = ({
  totalPages = 0,
  pageSize = 10,
  currentPage = 1,
  totalRecords = 1,
  onPageChange,
}) => {
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings
  ) as any

  const pageSizesSet = new Set<number>([10, 20, 50, 100, 500, 1000])

  if (generalSettings?.default_page_size && !pageSizesSet.has(generalSettings?.default_page_size)) {
    pageSizesSet.add(generalSettings?.default_page_size)
  }

  const pageSizes = Array.from(pageSizesSet).sort((a, b) => a - b)

  return (
    <div className='grid-pagination'>
      <div className='grid-pagination-pages' id='kt_table_users_paginate'>
        <ReactPaginate
          containerClassName='pagination'
          pageClassName='page-item'
          pageLinkClassName='page-link'
          activeClassName='active'
          nextClassName='page-item'
          nextLinkClassName='page-link'
          previousClassName='page-item'
          previousLinkClassName='page-link'
          breakClassName='page-item'
          breakLinkClassName='page-link'
          previousLabel={<i className='fa fa-chevron-left' aria-hidden='true' />}
          nextLabel={<i className='fa fa-chevron-right' aria-hidden='true' />}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={totalPages}
          forcePage={currentPage - 1}
          onPageChange={(page) => onPageChange(page.selected + 1, pageSize)}
        />
      </div>

      <div className='grid-pagination-meta'>
        <FilterSelect
          value={String(pageSize)}
          options={pageSizes.map((size) => ({value: String(size), label: String(size)}))}
          // The current page may not exist at the new size, so start over.
          onChange={(size) => onPageChange(1, Number(size))}
          triggerClassName='filter-select-solid filter-select-sm'
          ariaLabel='Page size'
        />

        <span className='grid-pagination-summary fs-6 fw-bold text-gray-700'>
          <FormattedMessage
            id='GENERAL.GRID_SHOWING_TOTAL'
            values={{
              x: totalRecords ? pageSize * currentPage - pageSize + 1 : 0,
              y: totalRecords < pageSize * currentPage ? totalRecords : pageSize * currentPage,
              total: totalRecords,
            }}
          />
        </span>
      </div>
    </div>
  )
}

export {Pagination}
